// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"515":"19a5e35f","642":"c56af1c2"}[chunkId] + ".chunk.js";
};